module.exports = __webpack_public_path__ + "static/media/hexagon.caf7947e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@wikipathways/pvjs/lib/icons/hexagon.svg
// module id = 674
// module chunks = 0